import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_TOKO, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_TOKO = 'GET_LIST_TOKO';

export const getToko = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_TOKO);

    axios({
      method: 'get',
      url: GET_TOKO,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_TOKO, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_TOKO,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_TOKO, error);
        alert(error);
      });
  };
};
